// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2pFT2","normal":"button_normal__1TG1J","primary":"button_primary__2Z9E_"};